import { ApiClient, ApiError } from '../core'

export type AuthAPI = {
  renewSession: () => Promise<void>
}

/**
 * call and identity provider endpoint to keep the session alive
 */
export function initializeAuthAPI(c: ApiClient): AuthAPI {
  const renewSession = async (): Promise<void> => {
    const res = await c.read<void>('IDP/Account/SilentRenewSession')
    if (res instanceof ApiError) {
      throw new Error(`💥 ${JSON.stringify(res)}`)
    }
  }

  return {
    renewSession,
  }
}
